import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const CryptoFields = ({ formData, onFieldChange }) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="wallet_address" className="portfolio-input-label">Wallet Address (Optional)</Label>
      <Input
        id="wallet_address"
        data-testid="wallet-address-input"
        placeholder="Blockchain wallet address"
        value={formData.wallet_address}
        onChange={(e) => onFieldChange('wallet_address', e.target.value)}
        className="portfolio-input"
      />
    </div>
  );
};

export default CryptoFields;
